/**
 * Returns a new object containing only the specified keys from the source
 * object. Intended for use in SurveyJS expressions to project a subset of
 * fields from a value loaded via `valueAsObject`-enabled choicesByUrl.
 *
 * Usage in expression:
 *   pick({handInLocation.address}, 'street', 'postalCode', 'city')
 */
export const pick = (params: unknown[]): Record<string, unknown> | null => {
  const [source, ...keys] = params;
  if (source === null || source === undefined || typeof source !== "object") {
    return null;
  }
  const result: Record<string, unknown> = {};
  for (const key of keys) {
    if (typeof key !== "string") continue;
    if (key in (source as Record<string, unknown>)) {
      result[key] = (source as Record<string, unknown>)[key];
    }
  }
  return result;
};
